import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import { Store as AuthStore } from "./context/Auth";
import { Store as IntegrationsStore } from "./context/Integrations";

import ScrollToTop from "./components/ScrollToTop";
import Landing from "./pages/Landing";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Support from "./pages/Support";
import ShortcutsList from "./pages/shortcuts/ShortcutsList";
import ShortcutDetail from "./pages/shortcuts/ShortcutDetail";

import theme from "./theme";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/support" element={<Support />} />
            <Route path="/shortcuts" element={<ShortcutsList />} />
            <Route path="/shortcuts/:slug" element={<ShortcutDetail />} />
        </Routes>
    );
};

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <ScrollToTop />
                <AuthStore>
                    <IntegrationsStore>
                        <AppRoutes />
                    </IntegrationsStore>
                </AuthStore>
            </Router>
        </ThemeProvider>
    );
}

export default App;
